import { clsx, type ClassValue } from "clsx";

/** Tiny class combiner used across the design system. */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
